export default "__VITE_PUBLIC_ASSET__e28987c7__"